export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'I was terrified of hamstring rehabilitation. I always feared a re-tear. After day 5 with 360° Muscle Recovery, I understood exactly how to bridge the gap between rest and load. By week 4, I was back to sprinting with zero fear. This system is a complete game-changer for muscle injuries.',
    name: 'Marcus T.',
    location: 'New York · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/ef84aa00-709f-456f-afe3-7c781c734823.jpg',
  },
  {
    quote:
      'I managed calf strains for months, frustrated because they kept coming back. The 360° method actually works. The focus on eccentric loading and neural reset made the difference. I am now back to my professional dance routine thanks to SIGMA SMART™.',
    name: 'Sofia L.',
    location: 'Toronto · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/549edc20-6760-465c-89a8-3b55e3eebd82.jpg',
  },
  {
    quote:
      "I was afraid I wasn't “expert enough” to manage a severe groin strain. 360° proved me wrong. The visual method makes the stages of muscle healing so clear. I felt confident from DAY ONE. I recommend this to every athlete I know.",
    name: 'David P.',
    location: 'Melbourne · Australia',
    flag: '🇦🇺',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/abeba4cf-9b76-477a-a5c3-062162635fc6.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'The tracking sheets live on my fridge now. I know exactly which load to add each week instead of guessing and flaring up my quad again. Six weeks in and the strain is gone.',
    name: 'James R.',
    location: 'Toronto · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/3efc2349-4a3b-468e-81ac-953c40807e03.jpg',
  },
  {
    quote:
      'The Lower Back Shield did it in three days. I had tried random YouTube routines for six months and always felt lost. Seeing the repair phases explained visually finally made sense.',
    name: 'Emma T.',
    location: 'London · UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/006283bb-3547-4bf4-a52d-f0c4cd279c9f.jpg',
  },
  {
    quote:
      'The 30-day roadmap is what kept me consistent. Twenty minutes a day, no wondering whether I was doing too much. Week 4 I was back under the barbell with no tweak.',
    name: 'Luis M.',
    location: 'California · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/b5b63af5-e9fe-4502-8311-a5389f278c65.jpg',
  },
  {
    quote:
      'I bought it for the calf protocols and stayed for the Shield routines. My Achilles stiffness of two years finally released. Worth far more than $19.',
    name: 'Rachel P.',
    location: 'Auckland · New Zealand',
    flag: '🇳🇿',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/031ff776-9181-4df9-8c44-942319e4a8c0.jpg',
  },
];
